<template lang="pug">
b-container(fluid)
    b-row(v-if="projects.length !== 0")
        b-col
            p Showing {{ projects.length }}
            b-table(hover='' 
                v-if='projects.length !== 0'
                :items='peptides' :fields='peptidesFields'
                :select-mode='selectMode'
                ref="projectsTable"
                selectable
                sort-icon-left
                responsive table-class="w-auto"
                @row-selected="onRowSelected")
</template>

<script>
import axios from 'axios'

const apiBaseUrl = '/scop3ptm/api/'
export default {
    name: 'Modifications',
    data: function() {
        return {
            modifications: []
        }
    },
    beforeMount: function() {
        if (this.$store.state.proteinId == null) {
            this.getProtein()
        }
        this.getModifications()
    },
    methods: {
        async getModifications() {
            const projectsUrl = apiBaseUrl + 'get-modifications'
            const response = await axios
                .get(projectsUrl, {
                    params: {
                        protein_id: this.$store.state.proteinId,
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            this.projects = response.data.projects
        }
    }
}
</script>

<style lang="scss">
@import '../assets/scss/variables';
</style>